import React from 'react';
import { forwardRef } from '@hover/blueprint/chakra';
import { Link, LinkProps, dArrowUpRight } from '@hover/blueprint/brand';

export interface ArrowLinkProps extends LinkProps {}

const ArrowLink = forwardRef<ArrowLinkProps, 'a'>((props, ref) => (
  <Link {...props} decorationAfter={dArrowUpRight} ref={ref} />
));

export default ArrowLink;
